<template>
  <div
    class="accordion__item"
    :class="{ 'accordion__item--open': open }"
  >
    <button
      type="button"
      class="accordion__item-header"
      :aria-controls="`item-${itemId}`"
      :aria-expanded="open"
      @click="selectItem"
    >
      <div class="accordion__item-header-content">
        <slot name="item-title" />
      </div>

      <div class="accordion__item-indicator">
        <span class="icon icon--smedium far fa-angle-right" />
      </div>
    </button>

    <transition :name="animated ? 'fade-down' : ''">
      <div
        v-show="open"
        class="accordion__item-content"
        :aria-hidden="!open"
      >
        <slot name="item-content" />
      </div>
    </transition>
  </div>
</template>



<script>
  export default {
    name: 'AccordionItem',

    props: {
      animated: {
        type: Boolean,
        default: true
      },
      itemId: {
        type: Number,
        required: true
      },
      open: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      selectItem() {
        this.$emit('accordion-item-selected', this.itemId);
      }
    }
  };
</script>
